import { useOrderPageStore } from 'src/modules/order/orderPageStore';

export function useOrderPageIsTableView() {
    const isTableView = useOrderPageStore((state) => state.isTableView);
    return isTableView;
}
